/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, array, object } from 'prop-types'
import { jsx, Flex, Text } from 'theme-ui'
import './formInputs.css'
import PercentGroupItem from './PercentGroupItem'

const PercentGroup = ({ answerSet, firstGroupComplete, selectedValues }) => {
  const groupLabel = answerSet[0].text.substring(
    0,
    answerSet[0].text.indexOf(' Current')
  )
  const groupFields = firstGroupComplete ? answerSet : [answerSet[0]]
  return (
    <Flex
      sx={{
        mb: 5,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '80%',
      }}
    >
      <Flex
        sx={{
          width: '70%',
        }}
      >
        <Text
          variant="smallText"
          data-automation-id={`percent-group-label-${groupLabel}`}
        >
          {groupLabel}
        </Text>
      </Flex>
      <Flex
        sx={{
          justifyContent: 'space-between',
          width: '30%',
        }}
      >
        {groupFields.map(answer => (
          <PercentGroupItem
            key={answer.id}
            answer={answer}
            value={selectedValues[answer.id] || ''}
          />
        ))}
      </Flex>
    </Flex>
  )
}

PercentGroup.propTypes = {
  answerSet: array,
  firstGroupComplete: bool,
  selectedValues: object,
}

export default PercentGroup
